// Mock data for MG Experts website

export const siteConfig = {
  name: "MG PROJECT & EXPERT SERVICES",
  tagline: "Partnering for Progress, Delivering Excellence",
  logo: "https://customer-assets.emergentagent.com/job_construct-consult-3/artifacts/ek5gz8rm_image.png",
  founderImage: "https://customer-assets.emergentagent.com/job_f67bdfa7-0cd7-4569-a079-d15329d17c4b/artifacts/eg9v9q6c_1618753517367.jfif",
  contact: {
    phone: "+91 9667575628",
    email: "info@mg-experts.com"
  }
};

export const founder = {
  name: "Maninder Gogia",
  title: "Owner & Managing Director",
  bio: [
    "Maninder Singh Gogia is a trusted leader in Project Management and Claims Advisory, bringing over 20 years of expertise in guiding complex construction projects to successful outcomes. Specializing in claims management, delay analysis, and forensic planning, Maninder has helped clients navigate high-stakes disputes across various industries, including infrastructure, civil engineering, and defense. His extensive experience spans projects in the UK, India, Afghanistan, and the Middle East, where he has earned a reputation for delivering reliable solutions that protect client interests and drive project success.",
    "As the founder of MG Projects and Services, Maninder is committed to offering personalized, strategic advice that empowers clients to resolve disputes efficiently and maximize value. His approach combines deep technical knowledge with a strong focus on proactive communication and transparency. Maninder understands that each project is unique, and he tailors his solutions to meet the specific needs and challenges of every client, ensuring that their cases are handled with the utmost care and attention to detail.",
    "Maninder's qualifications include a Master's in Construction Law and Dispute Resolution from King's College London, as well as membership in the prestigious Chartered Institute of Arbitrators. These credentials reflect his dedication to maintaining the highest standards of professionalism and ethical practice. With expertise in industry-leading tools like Primavera Project Planner and MS Project, Maninder ensures that his analyses and recommendations are backed by robust, data-driven insights.",
    "Clients trust Maninder for his ability to deliver results under pressure and his unwavering commitment to their success. From managing complex delay claims to guiding clients through adjudication, mediation, and arbitration, Maninder brings both the technical and strategic insights needed to achieve fair, timely resolutions. Under his leadership, MG Projects and Services has become a reliable partner for clients seeking clarity, confidence, and comprehensive support in their claims and dispute management needs."
  ]
};

export const aboutUs = {
  title: "About Us",
  content: [
    "At MG Projects and Services, we bring a wealth of experience and technical expertise in project management and construction claims advisory to the engineering and construction industry. Founded by Maninder Gogia, a highly accomplished professional with over 20 years of experience, our firm specializes in managing complex construction claims, delay analysis, and forensic planning across a diverse range of projects.",
    "Our commitment to excellence is reflected in our portfolio, which includes major infrastructure, civil, and military projects in multiple countries, including the UK, Afghanistan, India, and more. We have successfully partnered with global clients, providing critical insights and robust analysis to manage project schedules, resolve disputes, and ensure fair compensation for time and cost impacts."
  ]
};

export const ourApproach = {
  title: "Our Approach",
  content: "At MG Projects and Services, we believe in proactive communication, meticulous attention to detail, and a solutions-oriented approach. Our team is equipped with advanced project management tools like Primavera Project Planner, MS Project, and Asta Power Project, ensuring that every phase of planning and analysis is backed by data-driven insights. We work closely with clients, from project managers to commercial teams, to provide actionable recommendations that drive project success and minimize disputes."
};

export const services = [
  {
    id: 1,
    title: "Arbitration & Litigation Support",
    shortDesc: "Forensic claims preparation and expert witness support",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80",
    overview: "We provide forensic claims preparation, expert witness statements, and full claim packaging for arbitration and litigation. Our work supports counsels and claimants with clear, defensible schedules, document trails, and expert testimony.",
    deliverables: [
      "Forensic delay analysis undertaken in accordance with the SCL Delay and Disruption Protocol, using the most appropriate methodology based on project records, data availability, and dispute context",
      "Quantum assessments: cost/time entitlement evaluations with audit-ready schedules",
      "Preparation of expert reports and joint statements suitable for arbitration/mediation",
      "Court/adjudicator-ready visual exhibits (timeline graphics, gantt snapshots, annotated baseline)"
    ],
    process: "Rapid intake → evidence collection → baseline reconstruction → quantified claim → expert report → testimony support",
    outcomes: "Improved settlement positions, robust case evidence, reduced litigation duration"
  },
  {
    id: 2,
    title: "Project Planning & Delay Analysis",
    shortDesc: "CPM scheduling and forensic delay analysis",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80",
    overview: "Detailed project planning, CPM scheduling, and forensic delay analysis to quantify causes and impacts of delay across project lifecycles.",
    deliverables: [
      "Baseline development and validation (Primavera/MS Project)",
      "Detailed delay analysis using time-impact, windows analysis and as-built reconciliation",
      "Recovery planning and mitigation strategies with resource and cost implications",
      "Interactive schedule models, annotated Gantt and cause-effect matrices"
    ],
    whyItMatters: "Accurate identification of responsibility and delay attribution; faster, evidence-based resolution and better claims defensibility"
  },
  {
    id: 3,
    title: "Dispute Resolution Services",
    shortDesc: "Adjudication, mediation, and negotiation support",
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&q=80",
    overview: "Comprehensive dispute resolution to minimise escalation—adjudication, mediation, negotiation support and settlement structuring.",
    deliverables: [
      "Facilitation of mediation and settlement negotiations",
      "Adjudication support documentation and witness preparation",
      "Structured negotiation packages including quantified claims, risk allocation and recommended settlement terms"
    ],
    approach: "Neutral, pragmatic, and commercially-driven. We focus on preserving client value while delivering enforceable outcomes."
  },
  {
    id: 4,
    title: "4D Planning",
    shortDesc: "4D simulation for construction sequences",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80",
    overview: "Merge schedule and model (4D simulation) for visualising construction sequences, clash-free execution, and forensic scenario playback.",
    deliverables: [
      "4D sequence simulations tied to Primavera/MS Project schedules",
      "Animatable scenario exports for stakeholder briefings and adjudicator visual exhibits",
      "Time-based clash detection and constructability visualisations"
    ],
    benefits: "Clearer stakeholder alignment, faster dispute resolution through visual evidence, improved site planning"
  },
  {
    id: 5,
    title: "BIM Software Integration",
    shortDesc: "BIM support for schedule-model integration",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&q=80",
    overview: "Practical BIM support for schedule-model integration and data-driven project controls.",
    deliverables: [
      "BIM execution planning and process integration with project controls",
      "Model-based quantity checks and schedule linking",
      "Integration workflows for Primavera, MS Project, Navisworks, Revit and common BIM data exchanges",
      "Training and handover documentation"
    ],
    outcome: "Improved coordination, accurate project forecasting and reduced rework"
  }
];

export const sliderImages = [
  "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80",
  "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80",
  "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80",
  "https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=800&q=80",
  "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?w=800&q=80"
];
